// Метка свидетельства. Общая: её показывают и список открытых навыков, и
// карточка цели — про один и тот же навык, и разойтись в словах они не имеют
// права. До 11 сентября 2026 компонент жил внутри `screens/Progress.tsx`, а
// карточка цели рядом печатала свой счёт задач по своим правилам; два числа
// под одним утверждением — ровно то, чего проект избегает везде.

import { plural } from "../lib/dates";
import type { ProgressSnapshot } from "../api";

/**
 * Метка под навыком: чем подпёрто число владения.
 *
 * Три состояния, ровно те, что различает ученик: не знаем — прикидка —
 * проверено. Считает их сервер (`convex/lib/evidence.ts`), здесь только слова,
 * и это не мелочь: порог «подтверждено» — часть модели, а не оформления, и
 * посчитанный на экране он разошёлся бы с тем, что система утверждает о себе.
 *
 * Слов похвалы здесь нет и быть не может. «Проверено: 9 из 11» — это число, а
 * «отлично» на тех же одиннадцати задачах было бы оценкой, которую система не
 * вправе выставлять: она меряет владение, а не старание.
 */
export function EvidenceTag({
  skill,
}: {
  skill: ProgressSnapshot["openSkills"][number];
}) {
  if (skill.confidence === "none") {
    return <span className="tag tag--guess">оценка по карте</span>;
  }
  if (skill.confidence === "thin") {
    return (
      <span className="tag">
        по <span className="num">{skill.tried}</span>{" "}
        {plural(skill.tried, "задаче", "задачам", "задачам")}
      </span>
    );
  }
  return (
    <span className="tag tag--grow">
      проверено: <span className="num">{skill.correct}</span> из{" "}
      <span className="num">{skill.tried}</span>
    </span>
  );
}
